import React from "react";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";
import DashboardWidget from "@/components/DashboardWidget";

interface AnalyticsStats {
  locationStats: Array<{ location: string; count: number }>;
}

interface TopLocationsWidgetProps {
  stats: AnalyticsStats | null;
}

export const TopLocationsWidget: React.FC<TopLocationsWidgetProps> = ({
  stats,
}) => {
  return (
    <DashboardWidget
      id="top-locations"
      title="Top Performing Locations"
      headerActions={<MapPin className="h-5 w-5 text-green-600" />}
    >
      <div className="space-y-3">
        {stats?.locationStats?.slice(0, 5).map((location, index) => {
          const totalLocationVisitors =
            stats?.locationStats?.reduce((sum, loc) => sum + loc.count, 0) || 1;
          const percentage = (
            (location.count / totalLocationVisitors) *
            100
          ).toFixed(1);

          return (
            <div
              key={location.location}
              className="flex items-center justify-between"
            >
              <div className="flex items-center gap-3">
                <span className="flex items-center justify-center w-6 h-6 bg-green-600 text-white rounded-full text-xs font-bold">
                  {index + 1}
                </span>
                <div>
                  <span className="font-medium">{location.location}</span>
                  <div className="text-xs text-gray-500">
                    {percentage}% of all visits
                  </div>
                </div>
              </div>
              <Badge className="bg-gradient-to-r from-green-500 to-teal-600 text-white">
                {location.count}
              </Badge>
            </div>
          );
        }) || <p className="text-gray-500">No location data available</p>}

        {stats?.locationStats && stats.locationStats.length > 0 && (
          <div className="pt-3 border-t">
            <div className="text-sm text-gray-600 text-center">
              Total Locations:{" "}
              <span className="font-semibold">
                {stats.locationStats.length}
              </span>
            </div>
          </div>
        )}
      </div>
    </DashboardWidget>
  );
};

export default TopLocationsWidget;
